const parkingsReducer = (previousState = null, { type, payload }) => {
    if (type === 'UPDATE_PARKINGS') {
        return payload.parkings;
    }
    return previousState;
}
export default parkingsReducer;